import React, { Component } from 'react'
import { Spin, Divider, Table, DatePicker, Select, Form, Row, Col, ConfigProvider, Tooltip, Button } from 'antd'
import API from '../../services/API'
import moment from 'moment'
import locale from 'antd/es/date-picker/locale/es_ES'
import WeekPicker2 from '../../components/WeekPicker2'

import { getRangesWeeks } from '../../services/Utils'

locale.lang.firstDayOfWeek = 6
const { WeekPicker } = DatePicker
const { Option } = Select
class ReportAssistancesGeneralContainer extends Component {
    state = {
        loading: true,
        title: 'Semana',
        data: [],
        users: [],
        years: [],
        subsidiaries: [],
        currentWeek: '',
        currentYear: 0,
        currentUser: '',
        currentSubsidiary: '',
        query: '',
        currenDate: '',
    }

    constructor(props) {
        super()
        this.user = props.user
    }

    getCurrentWeek = () => {
        moment.updateLocale('es', {
            week: {
                dow: 5, // 0=domingo, 1=lunes, 2=martes, 3=miércoles, 4=jueves, 5=viernes, 6=sábado
            },
        })
        return moment().week()
    }

    componentDidMount() {
        let localSubsidiary = JSON.parse(localStorage.getItem('sucursal'))

        if (localSubsidiary) {
            localSubsidiary = parseInt(localSubsidiary.id)
        }
        const currentWeek = this.getCurrentWeek()
        const currentYear = moment().year()
        const ranges = getRangesWeeks(currentYear)

        const indexFind = ranges.findIndex(f => f.value === currentWeek)
        const option = ranges[indexFind]

        this.setState(
            {
                currentWeek,
                currentYear,
                dateRange: `${option.start},${option.end}`,
                currentSubsidiary: localSubsidiary,
                currentUser: this.user.id,
            },
            () => {
                this.getData()
            }
        )

        this.getSubsidiaries()
        this.getUsers()
    }

    onChangeWeek = async (value, options) => {
        console.log('week', options, value)
        this.setState(
            {
                currentWeek: value,
                dateRange: `${options.start}, ${options.end}`,
                loading: true,
            },
            () => {
                this.getData()
            }
        )
    }

    getUsers = async () => {
        this.setState({
            loading: true,
        })

        await API.get(`/api/users?pagination=false&filter[active]=1`)
            .then(response => {
                this.setState({
                    loading: false,
                    users: response.data,
                })
            })
            .catch(err => {
                console.error(err)
            })
    }

    getSubsidiaries = async () => {
        this.setState({
            loading: true,
        })

        await API.get('/api/subsidiaries?pagination=false&filter[active]=1')
            .then(response => {
                this.setState({
                    loading: false,
                    subsidiaries: response.data,
                })
            })
            .catch(err => {
                console.error(err)
            })
    }

    columns = [
        {
            title: 'DÍA',
            dataIndex: 'week',
            key: 'week',
        },
        {
            title: 'HORA ENTRADA',
            dataIndex: 'e',
            key: 'e',
        },
        {
            title: 'SALIDA (comida)',
            dataIndex: 'sc',
            key: 'sc',
        },
        {
            title: 'ENTRADA (comida)',
            dataIndex: 'ec',
            key: 'ec',
        },
        {
            title: 'HORA SALIDA',
            dataIndex: 's',
            key: 's',
        },
    ]

    getData = () => {
        const newQuery = `&dateRange=${this.state.dateRange}&user_id=${this.state.currentUser}&subsidiary_id=${this.state.currentSubsidiary}`

        this.setState({
            loading: true,
            query: newQuery,
        })

        API.get(`/api/assistances?json=true${newQuery}`)
            .then(response => {
                this.setState({
                    loading: false,
                    data: response.data.data,
                    years: response.data.years,
                    title: `SEMANA ${response.data.numberWeek}`,
                })
            })
            .catch(error => {
                console.error(error)
            })
    }

    render() {
        return (
            <>
                <div
                    style={{
                        backgroundColor: 'white',
                        borderRadius: 3,
                        padding: '8px 16px 16px',
                    }}
                >
                    <Spin spinning={this.state.loading} tip="Espere, por favor...">
                        <Divider>Reporte de asistencia general</Divider>

                        <Row gutter={24}>
                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Año">
                                    <Select
                                        style={{ width: '100%' }}
                                        value={this.state.currentYear}
                                        onChange={value => {
                                            const dates = this.state.dateRange.split(',')

                                            console.log('dates', dates, dates[0], dates[1])

                                            let startDate = moment(dates[0], 'YYYY-MM-DD')
                                            let endDate = moment(dates[1], 'YYYY-MM-DD')

                                            let newDateRange = `${moment(startDate)
                                                .year(value)
                                                .format('YYYY-MM-DD')},${moment(endDate)
                                                .year(value)
                                                .format('YYYY-MM-DD')}`

                                            console.log('dates', newDateRange, startDate, endDate)

                                            this.setState(
                                                {
                                                    currentYear: value,
                                                    dateRange: newDateRange,
                                                },
                                                () => {
                                                    this.getData()
                                                }
                                            )
                                        }}
                                    >
                                        {this.state.years
                                            ? this.state.years.map((item, index) => (
                                                  <Option key={index} value={item}>
                                                      {item}
                                                  </Option>
                                              ))
                                            : null}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Semana">
                                    <WeekPicker2
                                        year={this.state.currentYear}
                                        value={this.state.currentWeek}
                                        onChange={this.onChangeWeek}
                                    />
                                    {/*
                                   <WeekPicker
                                        locale={locale}
                                        onChange={this.onChangeWeek}
                                        placeholder="Selecciona una semana"
                                        defaultValue={this.state.currentWeek}
                                    />
                                   */}
                                </Form.Item>
                            </Col>

                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Sucursal">
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Selecciona una sucursal"
                                        optionFilterProp="children"
                                        value={this.state.currentSubsidiary}
                                        onChange={value => {
                                            this.setState(
                                                {
                                                    currentSubsidiary: value,
                                                },
                                                () => this.getData()
                                            )
                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        <Option key="0" value="">
                                            Todas las sucursales
                                        </Option>
                                        {this.state.subsidiaries.map(g => (
                                            <Option key={g.id} value={g.id}>
                                                {g.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col lg={4} md={12} sm={24}>
                                <Form.Item label="Usuario">
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Selecciona un usuario"
                                        optionFilterProp="children"
                                        value={this.state.currentUser}
                                        onChange={value => {
                                            this.setState(
                                                {
                                                    currentUser: value,
                                                },
                                                () => this.getData()
                                            )
                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {this.state.users.map(g => (
                                            <Option key={g.id} value={g.id}>{`${g.name} ${g.last_name}`}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <div className="ant-header-button">
                            <Tooltip title="Generar hoja de calculo" placement="left">
                                <Button
                                    style={{ marginRight: '10px' }}
                                    type="primary"
                                    shape="circle"
                                    icon="download"
                                    onClick={() =>
                                        (window.location.href =
                                            '/api/excel?table=assistances&pagination=false&json=false' +
                                            this.state.query)
                                    }
                                />
                            </Tooltip>
                        </div>

                        <Table dataSource={this.state.data} columns={this.columns} pagination={false} />
                    </Spin>
                </div>
            </>
        )
    }
}

export default ReportAssistancesGeneralContainer
